export default function strNotSet() {
    return '{not set}';
}
